export const equipmentDeck = [
  {
    name: 'equipment_deck_info',
    value: '',
    type: 'textarea',
    placeholder: 'INFO',
    className: 'mt-2'
  }
];
